/* eslint-disable react/forbid-prop-types,react/forbid-prop-types,no-unused-vars,react/no-danger,react/no-unused-prop-types,react/no-array-index-key */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import {clearAllBodyScrollLocks} from "body-scroll-lock";
import VisibilitySensor from 'react-visibility-sensor';
import {filterHTML} from "../../helpers/filters";
import './TimelineMilestone.scss';

class TimelineMilestone extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        entityBundle: PropTypes.string.isRequired,
        year: PropTypes.number,
        title: PropTypes.string.isRequired,
        fieldBackgroundColor: PropTypes.string,
        fieldBackgroundImageMedia: PropTypes.object,
        fieldSupportingImageMedia: PropTypes.object,
        parentState: PropTypes.object.isRequired,
        fieldColumnContent: PropTypes.array,
        goToNextPanel: PropTypes.func.isRequired,
        index: PropTypes.number.isRequired,
        isMobile: PropTypes.bool,
        setCurrentYearMobile: PropTypes.func.isRequired,
        isScrolling: PropTypes.bool,
        goToYearComplete: PropTypes.func.isRequired,
        scrollingTo: PropTypes.number
    };

    static defaultProps = {
        year: null,
        fieldBackgroundColor: '#333333',
        fieldBackgroundImageMedia: {
            entity: {
                fieldMediaImage: {
                    url: null,
                    alt: null
                }
            }
        },
        fieldSupportingImageMedia: {
            entity: {
                fieldMediaImage: {
                    url: null,
                    alt: null
                }
            }
        },
        fieldColumnContent: [],
        isScrolling: false,
        scrollingTo: null,
        isMobile: false,
    };

    constructor(props) {
        super(props);
        this.timelineMilestoneRef = React.createRef();
    }

    state = {
        mounted: false
    };

    componentDidMount() {
        if (!this.state.mounted) {
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({mounted: true});
        }
    }

    componentDidUpdate(prevProps) {

        // Scroll to Component on Mobile
        if (this.props.isMobile &&
            this.props.isScrolling &&
            this.props.scrollingTo === this.props.index) {
            this.scrollToThis();
        }

    }

    getIntro = () => {
        const {year, title, goToNextPanel} = this.props;

        // Intro only conditionals
        let introTitle;
        let introScrollTarget;
        let introSocial;

        if ( !year ) {
            introTitle = (
                <div className="timelineMilestone__introTitle">
                    <img src="/public/images/timelineMilestones/intro/25-Lockup_White.svg" className="timelineMilestone__introLogo" alt="25 Years - Market Axess"/>
                    <h1>
                        {title}
                    </h1>
                </div>
            );

            introScrollTarget = (
                <button className="timelineMilestone__introScrollTarget" onClick={goToNextPanel}>
                    <img src="/public/images/timelineMilestones/intro/icon__scrollDown.svg" alt="20 Years - Market Axess"/>
                </button>
            );


            introSocial = (
                <ul className="timelineMilestone__introSocial">
                    <li>
                        <a href="/timeline_milestone">
                            <img src="/public/images/timelineMilestones/intro/icon__link.svg" alt="Link"/>
                            <span className="screen-reader-text">Copy the Link for this page</span>
                        </a>
                    </li>
                    <li>
                        <a href="mailto:?subject=20%20Years%20of%20Market%20Axess%20Transforming%20Global%20Markets&body=https%3A%2F%2Fwww.marketaxess.com%2Ftimeline_milestone">
                            <img src="/public/images/timelineMilestones/intro/icon__envelope.svg" alt="Mail icon"/>
                            <span className="screen-reader-text">Share this by email</span>
                        </a>
                    </li>
                </ul>
            );
        }

        return {
            introTitle,
            introSocial,
            introScrollTarget
        };
    };

    getColumns = () => {
        const {fieldColumnContent} = this.props;

        const columns = [];
        let singleTitle = null;

        fieldColumnContent.forEach((column, index) => {
            const content = filterHTML(column.processed);
            const contentTitle = content.match(/<\s*h2[^>]*>(.*?)<\s*\/s*h2>/);

            // Get Title from First Column
            if (!singleTitle && contentTitle && contentTitle[0]) {
                singleTitle = contentTitle[0];
            }

            columns.push({
                index,
                title: contentTitle && contentTitle[0] ? contentTitle[0] : null,
                content: content.replace(/<\s*h2[^>]*>(.*?)<\s*\/s*h2>(\n+)?/, '')
            });
        });

        return {
            singleTitleOnly: !!(singleTitle &&  columns.length > 1 && columns.every(column => column.index === 0 || !column.title)),
            singleTitle,
            columns
        };
    };

    generalPanels = () => {
        const {year} = this.props;

        // General panels only conditionals
        let panelTitle;
        let panelLines;

        if (year) {

            panelTitle = <h2 className="timelineMilestone__title" aria-label={year}>
                {`${year}`.split("").map((char, index) => (<span aria-hidden="true" key={index}>{char}</span>) )}
            </h2>;

            panelLines = <div className="panelDateLinesWrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 405 25.5" className="panelDateLines"><g><g stroke="#FFFFFF" fill="none"><line x1="0.5" x2="0.5" y2="15.8"/><line x1="14.1" x2="14.1" y2="25.5"/><line x1="27.4" x2="27.4" y2="15.8"/><line x1="41" x2="41" y2="25.5"/><line x1="54.3" x2="54.3" y2="15.8"/><line x1="67.9" x2="67.9" y2="25.5"/><line x1="81.2" x2="81.2" y2="15.8"/><line x1="94.8" x2="94.8" y2="25.5"/><line x1="108.1" x2="108.1" y2="15.8"/><line x1="121.7" x2="121.7" y2="25.5"/><line x1="134.9" x2="134.9" y2="15.8"/><line x1="148.6" x2="148.6" y2="25.5"/><line x1="161.8" x2="161.8" y2="15.8"/><line x1="175.5" x2="175.5" y2="25.5"/><line x1="188.7" x2="188.7" y2="15.8"/><line x1="202.3" x2="202.3" y2="25.5"/><line x1="215.6" x2="215.6" y2="15.8"/><line x1="229.2" x2="229.2" y2="25.5"/><line x1="242.5" x2="242.5" y2="15.8"/><line x1="256.1" x2="256.1" y2="25.5"/><line x1="269.4" x2="269.4" y2="15.8"/><line x1="283" x2="283" y2="25.5"/><line x1="296.3" x2="296.3" y2="15.8"/><line x1="309.9" x2="309.9" y2="25.5"/><line x1="323.2" x2="323.2" y2="15.8"/><line x1="336.8" x2="336.8" y2="25.5"/><line x1="350.3" x2="350.3" y2="15.8"/><line x1="363.9" x2="363.9" y2="25.5"/><line x1="377.4" x2="377.4" y2="15.8"/><line x1="391" x2="391" y2="25.5"/><line x1="404.5" x2="404.5" y2="15.8"/></g></g></svg></div>;

        }

        return {
            panelTitle,
            panelLines,
        };
    };

    scrollToThis = () => {
        clearAllBodyScrollLocks();

        if (!this.timelineMilestoneRef) return;

        this.timelineMilestoneRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };

    render() {
        const {id, entityBundle, year, fieldBackgroundColor, fieldBackgroundImageMedia, fieldSupportingImageMedia, fieldColumnContent, isMobile, isScrolling, setCurrentYearMobile} = this.props;

        const numberOfColumns = fieldColumnContent.length;

        let background = `${fieldBackgroundColor}`;
        if (fieldBackgroundImageMedia && fieldBackgroundImageMedia.entity && fieldBackgroundImageMedia.entity.fieldMediaImage && fieldBackgroundImageMedia.entity.fieldMediaImage.url) {
            background = `${background} url('${fieldBackgroundImageMedia.entity.fieldMediaImage.url}') no-repeat center center/cover`;
        }

        let mobileBackground = `${fieldBackgroundColor}`;
        if (fieldSupportingImageMedia && fieldSupportingImageMedia.entity && fieldSupportingImageMedia.entity.fieldMediaImage && fieldSupportingImageMedia.entity.fieldMediaImage.url) {
            mobileBackground = `${mobileBackground} url('${fieldSupportingImageMedia.entity.fieldMediaImage.url}') no-repeat center center/cover`;
        } else if (fieldBackgroundImageMedia && fieldBackgroundImageMedia.entity && fieldBackgroundImageMedia.entity.fieldMediaImage && fieldBackgroundImageMedia.entity.fieldMediaImage.url) {
                mobileBackground = `${mobileBackground} url('${fieldBackgroundImageMedia.entity.fieldMediaImage.url}') no-repeat center center/cover`;
        }

        const intro = this.getIntro();
        const panels = this.generalPanels();
        const inProp = (this.props.index === this.props.parentState.currentIndex);

        let timelineMilestoneClass = `timelineMilestone timelineMilestone-id-${id} timelineMilestone-year-${year || 'intro'}`;
        if (this.props.index === 0 && this.state.mounted) {
            timelineMilestoneClass += ' timelineMilestone--introLoaded';
        }

        const columns = this.getColumns();

        const inner = (
            <section className={timelineMilestoneClass} ref={this.timelineMilestoneRef}>
                <div className="timelineMilestone__bg" style={{background}} />
                <div className="timelineMilestone__bg--sm" style={{background: mobileBackground}} />

                <div className="timelineMilestone__container">

                    {intro.introTitle}

                    {intro.introScrollTarget}

                    {panels.panelTitle}
                    {panels.panelLines}

                    {columns.singleTitleOnly ? <div className="timelineMilestone__subtitle" dangerouslySetInnerHTML={{__html: columns.singleTitle}} /> : null}

                    <div className={`timelineMilestone__grid timelineMilestone__grid--${numberOfColumns}`}>
                        {columns.columns.map((column, index) => (
                            <div key={`timelineMilestone__column--${index}`} className="timelineMilestone__column" dangerouslySetInnerHTML={{__html: !columns.singleTitleOnly && column.title ? `${column.title}\n\n${column.content}` : column.content}}/>
                        ))}
                    </div>

                    {intro.introSocial}



                </div>
            </section>
        );

        // Render Mobile View
        if (this.props.isMobile) return (
            <VisibilitySensor onChange={() => {
                if (!isScrolling && isMobile && this.state.mounted) {
                    setCurrentYearMobile(year);
                }
                if (isScrolling && isMobile && this.props.scrollingTo === this.props.index) {
                    this.props.goToYearComplete();
                }
            }} intervalCheck partialVisibility={'top'} scrollCheck scrollDelay={0}>
                {inner}
            </VisibilitySensor>
        );

        // Render Desktop View
        return (
			<CSSTransition
				key={`timelineMilestoneSlide__${year || 'intro'}`}
				in={inProp}
                timeout={{
                    appear: 0,
                    enter: 4000,
                    exit: 4000,
                }}
				classNames="tlmSlide"
                unmountOnExit={!isMobile}
			>
                {inner}
            </CSSTransition>
        )
    }
}

export default TimelineMilestone;



// WEBPACK FOOTER //
// ./frontend/components/TimelineMilestone/TimelineMilestone.jsx